export const DEFAULT_PROSPECT_FILTERS = {
  search: "",
  status: null,
  page: 1,
  perPage: 25,
};

export const PROSPECT_STATUS_OPTIONS = [
  { value: null, label: "All" },
  { value: "lead", label: "Lead" },
  { value: "converted", label: "Converted" },
];

export const buildProspectsListQuery = (
  filters,
  basePath = "super-admin/sale-leads"
) => {
  const params = new URLSearchParams();

  if (filters.search) {
    params.append("search", filters.search);
  }

  if (filters.status) {
    params.append("status", filters.status);
  }

  params.append("page", String(filters.page || 1));
  params.append("per_page", String(filters.perPage || 25));

  const query = params.toString();
  return query ? `${basePath}?${query}` : basePath;
};

export const hasActiveProspectFilters = (filters) =>
  Boolean(filters.search || filters.status);
